import apiClient from '@/config/api';
import { Token } from '@/types/auth';
import { User } from '@/types/user';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface TelegramAuthRequest {
  init_data: string;
}

export interface RefreshTokenRequest {
  refresh_token: string;
}

export const authApi = {
  loginTelegram: async (initData: string): Promise<Token> => {
    console.log('authApi.loginTelegram: Sending request to /auth/telegram')
    console.log('authApi.loginTelegram: API_URL:', import.meta.env.VITE_API_URL)
    console.log('authApi.loginTelegram: initData length:', initData?.length || 0)
    console.log('authApi.loginTelegram: Full initData:', initData)
    try {
      const requestBody = {
        init_data: initData,
      };
      console.log('authApi.loginTelegram: Request body:', JSON.stringify(requestBody).substring(0, 200) + '...')
      const response = await apiClient.post<Token>('/auth/telegram', requestBody);
      console.log('authApi.loginTelegram: Response received')
      return response.data;
    } catch (error: any) {
      console.error('authApi.loginTelegram: Error:', error)
      console.error('authApi.loginTelegram: Response:', error.response?.data)
      console.error('authApi.loginTelegram: Status:', error.response?.status)
      throw error;
    }
  },

  loginEmail: async (email: string, password: string): Promise<Token> => {
    const formData = new FormData();
    formData.append('username', email);
    formData.append('password', password);
    
    const response = await apiClient.post<Token>('/auth/login', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return response.data;
  },

  refreshToken: async (refreshToken: string): Promise<Token> => {
    const response = await apiClient.post<Token>('/auth/refresh', {
      refresh_token: refreshToken,
    });
    return response.data;
  },

  logout: async (): Promise<void> => {
    await apiClient.post('/auth/logout');
  },

  getMe: async (): Promise<User> => {
    const response = await apiClient.get<User>('/users/me');
    return response.data;
  },
};
